/* eslint-disable */
export const StatusCodes = {
    BAD_REQUEST: 400,
    FORBIDDEN: 403,
    SERVICE_UNAVAILABLE: 503,
    NOT_FOUND: 404,
    CONFLICT: 409,
}
